import { Col, Modal, Row } from "reactstrap";

interface ToggleModalProps {
  show: any;
  onToggleClick: any;
  onCloseClick: any;
  isEnabling?: boolean;
  clientName?: string;
}

const ToggleModal = ({
  show,
  onToggleClick,
  onCloseClick,
  isEnabling = false,
  clientName = ""
}: ToggleModalProps) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="sm">
      <button
        onClick={onCloseClick}
        type="button"
        className="close position-absolute confirm-modal-close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div className="modal-body pt-4">
        <div className="text-center mb-3">
          <i className="mdi mdi-alert-circle-outline confirm-modal-icon" />
          <h5 className="mt-2">Are you sure?</h5>
          <p>
            {`Do you want to disable ${clientName ? `${clientName}` : 'this client'} ?`}
          </p>
        </div>
        <hr className="my-3" />
        <Row className="g-2 justify-content-between">
          <Col xs={6} md="auto">
            <button
              type="button"
              className="btn btn-primary button-primary w-100"
              onClick={onToggleClick}
            >
              <i className="mdi mdi-toggle-switch-off-outline me-1"></i>
              Yes, disable it!
            </button>
          </Col>
          <Col xs={6} md="auto">
            <button
              type="button"
              className="btn btn-danger button-secondary confirm-modal-cancel w-100"
              onClick={onCloseClick}
            >
              <i className="mdi mdi-close me-1"></i>
              Cancel
            </button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ToggleModal;
